<template>
    <div class="navigation-main" v-if="canShowNavigation">
        <div class="icon-l" :class="{['btn-primary'] : tabSelected === 'list'}" @click="changeTab('list')">
            <i class="fa-solid fa-list"></i>
            {{ $t('dash.posts.nav.list') }}
        </div>

        <div class="icon-l" :class="{['btn-primary'] : tabSelected === 'planner'}" @click="changeTab('planner')">
            <i class="fa-regular fa-calendar"></i>
            <template v-if="tabSelected === 'planner'">
                {{ currentViewType == 'timeGridWeek' ? $t('dash.posts.nav.week') : $t('dash.posts.nav.month') }}
                <i class="fa-solid fa-caret-down"></i>
            </template>
            <template v-else>
                {{ $t('dash.posts.nav.calendar') }}
            </template>
        </div>
        <div class="icon-l" 
            :class="{['btn-primary'] : tabSelected === 'feed', disable: !isPageInstagramSelected}"
            @click="() => isPageInstagramSelected && changeTab('feed')"
        >
            <i class="fa-brands fa-instagram"></i>
            Feed
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tabSelected: String,
            currentViewType: String,
        },

        methods: {
            changeTab(tabName) {
                if (this.tabSelected == tabName && tabName == 'planner') this.$emit('switchCurrentViewType')
                this.$emit('changeTab',tabName)
            },

           
        },
        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            isPageInstagramSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].filter(id => this.allPages[id] && this.allPages[id].network == 'instagram').length;
            },
            currentUser() {
                return this.$store.getters['users/getCurrentUser']
            },
            canShowNavigation() {
                return true
                return this.currentUser?._premium?.plan > 1;
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>